import { createFileRoute } from "@tanstack/react-router";
import { MaskRedirect } from "@/features/shared/route-masking";

export const Route = createFileRoute("/admin/subscriptions/create")({
  component: () => (
    <MaskRedirect
      to="/admin/subscriptions"
      action="create"
      mask="/admin/subscriptions/create"
    />
  ),
});
